import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaAbTestsContextInterface } from '../schema/ab-tests-context.interface';

export class Snowplow2StatsAdapterSchemaAbTestsContext implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaAbTestsContextInterface {
    return {
      schema: 'iglu:ae.propertyfinder/ab_tests_context/jsonschema/1-0-0',
      data: {
        ab_tests: Object.keys(this.context.global.abTests).map((test) => {
          let variant = null;

          Object.keys(this.context.global.abTests[test].variants).forEach((testVariant) => {
            if (this.context.global.abTests[test].variants[testVariant]) {
              variant = testVariant;
            }
          });

          return {
            test,
            variant,
          };
        }),
      },
    };
  }
}
